import { AnalyticsSource } from '@b-stock/fe-core/bstock-react'

import { useFeatureBadgeEventProps } from '@/helpers/featureBadges/pageFeatureBadges'
import type { CombinedListingSearchResult } from '@/queries/CombinedListingSearchResult'

export const COMPARE_BID_TYPE = 'comparison_single_bid' as const
export const COMPARE_BID_SOURCE = AnalyticsSource.HOME_PORTAL

type ListingsBidOnEntry = {
  listing_id: string
  storefront_name: string
}

export const toListingsBidOn = (
  listings: CombinedListingSearchResult[]
): ListingsBidOnEntry[] =>
  listings.map((listing) => ({
    listing_id: listing.listingId,
    storefront_name: listing.storefrontName,
  }))

/** Beta badge fields for Compare's events, written once for all seven. */
export const useCompareBadgeProps = () =>
  useFeatureBadgeEventProps('compare_listings')
